export const filter = {
  id : '',  
  device_type_name: '', 
  created_at: '',
  updated_at: ''  
};
